/** One placed block in designer column/row units. */
export interface IGridCell {
  id: number;
  x: number;
  y: number;
  w: number;
  h: number;
}

/**
 * Cells Gridstack moved away from the coordinates the designer last stored.
 * A drop pushes overlapping neighbors, so the pointer block is not the only change.
 * Unknown ids are left out: they are not blocks this section is saving.
 */
export const changedGridCells = (
  stored: ReadonlyArray<IGridCell>,
  live: ReadonlyArray<IGridCell>
): IGridCell[] => {
  const storedById = new Map(stored.map((cell) => [cell.id, cell]));

  return live.filter((cell) => {
    const previous = storedById.get(cell.id);

    if (!previous) {
      return false;
    }

    return previous.x !== cell.x
      || previous.y !== cell.y
      || previous.w !== cell.w
      || previous.h !== cell.h;
  });
};
